interface Greeting {
  app: string;
  servedAt: Date;
}

function render({ app, servedAt }: Greeting): string {
  return `${app} is live, served at ${servedAt.toISOString()}`;
}

const target = document.querySelector<HTMLParagraphElement>("#greeting");

if (target) {
  target.textContent = render({ app: "faux-expensify", servedAt: new Date() });
}
